$(function(){
    const ticketsList = $('.js-tourgrade');
    const subtitle = $('.js-information-sidebar__option.is-active')
        .data('subtitle');
    $('.js-information__subtitle').text(subtitle);

    let tourWithError = $('.js-products-wrap .js-field-dropdown__label.has-error');

    if (tourWithError.length) {
        tourWithError.closest('.sidebar-top__wrap').get(0).scrollIntoView();
    }

    $('.js-information-sidebar__option').on('click', function chooseTypeAdmission() {
        if ($(this).hasClass('is-active')) return;

        const prodId = $(this).data('id');
        const $optionTitle = $(this).data('subtitle');
        const $cost = $(this).find('.js-information-sidebar-option__cost')
            .text();

        const $chosenSticky = $('.js-information__sticky[data-id="' + prodId + '"]');
        const $chosenContent = $('.js-information__content[data-id="' + prodId + '"]');
        const $chosenOrder = $('.js-information__order[data-id="' + prodId + '"]');
        const $chosenReviews = $('.js-keyvisual__reviews[data-id="' + prodId + '"]');
        const $chosenPictures = $('.js-keyvisual__carousel[data-id="' + prodId + '"]');

        if (typeof productDates !== 'undefined') {
            let datesId = $(this).data('product-id') ? $(this).data('product-id') : $(this).data('id');
            availableDates = productDates[datesId];
            applyFlatPickr();
        }

        $('.js-information__sticky, .js-information__content, .js-information__order, .js-keyvisual__reviews, .js-keyvisual__carousel')
            .addClass('hidden');

        $($chosenSticky).removeClass('hidden');
        $($chosenContent).removeClass('hidden');
        $($chosenOrder).removeClass('hidden');
        $($chosenReviews).removeClass('hidden');
        $($chosenPictures).removeClass('hidden');

        $('.js-keyvisual__carousel').css('display', 'none');
        $($chosenPictures).css('display', 'block');

        $('.js-carousel').owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            navClass: ['keyvisual-carousel__btn keyvisual-carousel__btn_prev', 'keyvisual-carousel__btn keyvisual-carousel__btn_next'],
            navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
            responsive: {
                0: {
                    items: 1,
                    autoHeight: true
                },

                1179: {
                    items: 1,
                    autoHeight: false
                }
            }
        });

        let $orderWrapTourgrade = $('.js-information__order[data-id="' + $(this).data('id') + '"] .js-tourgrade-wrap .js-tourgrade');

        if ($orderWrapTourgrade.data('auto-fetch')) {
            $orderWrapTourgrade.first().trigger('click');
        }

        if (typeof form != 'undefined') {
            if (!$('.js-information__error-box').hasClass('hidden')) {
                $('.js-information__error-box').addClass('hidden');
                $(form).closest('.js-field-dropdown__label.has-error')
                    .removeClass('has-error');
            }
        }


        $('.js-information-sidebar__option').removeClass('is-active');

        $('.js-information__subtitle').text($optionTitle);
        $('.js-information-ticket__cost').text($cost);

        $(this).addClass('is-active');

        getOptions();

        if ($(window).outerWidth() > 767) return;

        const $parent = $(this).parent('.js-information-sidebar__top');
        const parentBottom = $parent.offset().top + $parent.outerHeight();
        const elHeight = $(this).outerHeight();
        const headerHeight = $('.js-header').outerHeight();

        $('html, body').animate({
            scrollTop: parentBottom - elHeight - headerHeight
        }, 1100);

        if ($('.js-tourgrade').data('auto-fetch')) {
            $('.js-tourgrade').first().trigger('click');
        }
    });

    $('.js-information-content-list__btn').on('click', function chooseTab(e) {
        e.preventDefault();
        if ($(this).hasClass('is-active')) return;

        const $tabId = $(this).data('target');
        const elOffset = $(this).offset().top;
        const headerHeight = $('.js-header').outerHeight();
        const $btnsWrap = $(this).closest('.js-information-content-list');
        const $contentWrap = $btnsWrap.siblings('.js-information-content-tabs');

        $btnsWrap.find('.js-information-content-list__btn').removeClass('is-active');
        $contentWrap.find('.js-information-content-tabs__el').removeClass('is-active');

        $(this).addClass('is-active');
        $contentWrap.find('[data-id="' + $tabId + '"]').addClass('is-active');

        if (!$(this).data('static')) {
            $('html, body').animate({
                scrollTop: elOffset - headerHeight,
                duration: 3000
            });

            return;
        }

        if ($(window).width() > 767) return;

        const $parent = $(this).closest('.js-information-content-list');
        const parentBottom = $parent.offset().top + $parent.outerHeight();
        const elHeight = $(this).outerHeight();

        $('html, body').animate({
            scrollTop: parentBottom - elHeight - headerHeight
        }, 1100);
    });

    applyFlatPickr();

    function applyFlatPickr() {
        let flatpickrOptions = {
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'Y-m-d',
            minDate: 'today',
            defaultDate: 'today',
            disableMobile: false,
            wrap: true
        };

        if (typeof availableDates === 'undefined' || !availableDates || !availableDates.length) {
            return $('.flatpickr').flatpickr(flatpickrOptions);
        }

        var defaultDateOverride = $('.flatpickr').data('defaultvalue');
        if (defaultDateOverride != undefined && defaultDateOverride != '') {
            flatpickrOptions.defaultDate = defaultDateOverride;
        }
        else {
            flatpickrOptions.defaultDate = availableDates[0];
        }
       
        flatpickrOptions.enable = availableDates;

        $('.flatpickr').flatpickr(flatpickrOptions);
    }
    
    applyFlatPickrRange();

    function applyFlatPickrRange() {
        let flatpickrOptions = {
            mode: 'range',
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'Y-m-d',
            minDate: 'today',
            disableMobile: false,
            wrap: true
        };

        var defaultDate = $('.flatpickr-range').data('defaultvalue');
        if (defaultDate != undefined && defaultDate != '') {
            flatpickrOptions.defaultDate = defaultDate;
        }

        if (typeof availableDates === 'undefined' || !availableDates || !availableDates.length) {
            return $('.flatpickr-range').flatpickr(flatpickrOptions);
        }

        flatpickrOptions.defaultDate = availableDates[0];
        flatpickrOptions.enable = availableDates;

        $('.flatpickr-range').flatpickr(flatpickrOptions);
    }

    getOptions();

    function getOptions() {
        $('.js-book-now').attr('disabled', true);
        $('.js-field-dropdown__subtotal-wrap').removeClass('is-show');
        $('.js-field-dropdown__non-refundable-wrap').removeClass('is-show');

        const choosenTour = $('.js-information-sidebar__option.is-active').data('id');

        /* TODO rewrite*/
        if ($('.js-information-sidebar__option.is-active').data('sortAgeBands') === 1) {

            $('.js-field-dropdown__tickets .js-scrollbar .js-field-dropdown-tickets__field').each(function () {
                $(this).closest('.js-field-dropdown-tickets__category').hide();

                if ($(this).data('variation') === choosenTour) {
                    $(this).closest('.js-field-dropdown-tickets__category').show();
                }

            });

            return;
        }

    if (
      typeof availableDates !== "undefined" &&
      availableDates[0] == "1970-01-01"
    ) {
      $(".js-field-dropdown__tour").attr("disabled", true);
      $(".js-field-dropdown__tour")
        .parent(".js-field-dropdown__label")
        .addClass("is-disabled");
    }

        $('.js-field-dropdown__field_btn[name="tour"]')
            .val('Select Tour Option');
        $('.js-field-dropdown__field_btn[name="tour"]')
            .data('value', null);
        $('.js-field-dropdown__field_btn[name="tickets"]')
            .val('Select Tickets');

        $('.js-field-dropdown__tickets .js-product-field').each(function() {
            if ($(this).data('disabled') == 1) {
                $(this).attr('disabled', true);
            }
        });




        $('.field-dropdown__wrap').removeClass('has-value');

        if ($('.js-information-sidebar__option').length == 0 || $('.js-multiproducts').length) {
            return;
        }

        const optionsWrap = $('.js-tourgrade-wrap .js-scrollbar');

        if (ticketsList.length <= 1) {
            return;
        }

        for (let i = 0; i < ticketsList.length; i++) {
            if ($(ticketsList[i]).data('id') === 'undefined' || !$(ticketsList[i]).data('id')) {
                $(ticketsList[i]).show();
                continue;
            }

            $(ticketsList[i]).hide();
            let groupIds = $(ticketsList[i]).data('id').toString();
            if (!groupIds) continue;
            if (groupIds.split(',').indexOf(choosenTour.toString()) !== -1) {
                $(ticketsList[i]).show();
                $(optionsWrap).append(ticketsList[i]);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/information.js